import { useEffect, useRef } from "react";

// Calls `onSentBack` each time the gateway sends the response just handed in
// back to be tried again (correct-until-correct). The screen unlocks and
// shows the learner's work as it was, marked; it never decides this itself.
const useSentBack = (verdict, onSentBack) => {
  const tries = verdict && !verdict.moving ? verdict.tries : null;
  const last = useRef(tries);
  const callback = useRef(onSentBack);
  callback.current = onSentBack;
  useEffect(() => {
    if (!tries || tries === last.current) return;
    last.current = tries;
    callback.current(verdict.kind);
  }, [tries, verdict]);
};

export default useSentBack;
